module.exports = __webpack_public_path__ + "static/img/department2.2151e1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/home/department2.png
// module id = 6Xjb
// module chunks = 1